import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import DeliveryListComponent from './DeliveryListComponent';

import { getBuildingsForFilter } from '../Building/actionCreators';
import { getDeliveryTypes } from '../DeliveryTypes/actions';
import { getUnitsWithContacts } from '../Unit/actionCreators';
import { getDeliveries } from './actions';

import {
  getFrequencyStats,
  getTodayCount,
  shouldSkipTodayCountReq,
} from '../../utils';

import { DELIVERY_LIST_KEY } from './constants';

import * as buildingSelectors from '../Building/selectors';

const DeliveryListContainer = (props) => {
  const { onGetDeliveries, listParams, packageChanged, getItems } = props;
  const [modalData, setModalData] = useState({});

  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetDeliveries(queryParams);
  };

  const onRefreshList = () => getItems(listParams);

  useEffect(() => {
    if (packageChanged) onRefreshList();
  }, [packageChanged]);

  return (
    <DeliveryListComponent
      {...props}
      onExport={onExport}
      onRefreshList={onRefreshList}
      modalData={modalData}
      setModalData={setModalData}
    />
  );
};

DeliveryListContainer.defaultProps = {
  packageChanged: 0,
};

DeliveryListContainer.propTypes = {
  getItems: PropTypes.func.isRequired,
  onGetDeliveries: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
  packageChanged: PropTypes.number,
};

const mapStateToProps = (state, ownProps) => {
  const { deliveries, common, buildings, units, lists } = state;

  const { buildingId, building } = ownProps;

  return {
    items: deliveries,
    listKey: DELIVERY_LIST_KEY,
    listParams: lists?.[DELIVERY_LIST_KEY] || {},
    buildings,
    user: common.currentUser,
    deliveryTypes: common.deliveryTypes,

    units,
    building: buildingId
      ? buildingSelectors.getBuildingById(state, buildingId)
      : building,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: (params) => {
    getBuildingsForFilter(dispatch, params);
    getDeliveryTypes(dispatch, { ...params, disable_pagination: true });
  },
  getItems: async (queryParams) => {
    const res = await getDeliveries(dispatch, queryParams);
    if (shouldSkipTodayCountReq(res, queryParams)) return;
    res && getTodayCount(getDeliveries, dispatch, queryParams);
  },
  onGetDeliveries: (queryParams) => getDeliveries(dispatch, queryParams, true),
  onGetChartData: (queryParams) =>
    getFrequencyStats(getDeliveries, dispatch, queryParams),
  getUnits: (buildingId) => getUnitsWithContacts(dispatch, buildingId),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeliveryListContainer);
